import { useEffect } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Studio from "@/components/Studio";
import Services from "@/components/Services";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import { trackView } from "@/lib/track";

export default function Home() {
  useEffect(() => {
    trackView("/");
  }, []);

  return (
    <div
      data-testid="home-page"
      className="min-h-screen bg-[#09090B] text-white font-body"
    >
      <Header />
      <main>
        <Hero />
        <Services />
        <Studio />
        <About />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
